module.exports = __webpack_public_path__ + "img/gb953.prt.089d67b0.jpg";